/**
 * API origin shared by axios (AuthContext) and fetch-based clients (RAG SSE).
 * Empty string => same-origin relative paths (Docker nginx on :8000).
 */
export function getApiBase() {
  const raw = process.env.REACT_APP_API_URL || '';
  return String(raw).replace(/\/$/, '');
}

export function apiUrl(path) {
  const base = getApiBase();
  const p = path.startsWith('/') ? path : `/${path}`;
  return base ? `${base}${p}` : p;
}
